import { useSEO } from "../lib/seo";
import { Reveal } from "../components/Reveal";
import { PageHero } from "../components/PageHero";
import { EstimateForm } from "../components/EstimateForm";

const GetEstimatePage = () => {
  useSEO(
    "Get a Free Cleaning Estimate | Kay's Carpet Cleaning Gold Coast",
    "Tell Kay's Carpet Cleaning what you need cleaned and receive a free, no-obligation estimate based on your job. Gold Coast wide. Call 0450 311 907."
  );

  return (
    <div data-testid="get-estimate-page">
      <PageHero
        overline="Free & No-Obligation"
        title="Quick Cleaning"
        titleItalic="Estimate"
        text="Tell us a little about the job. The more information you provide, the easier it is for us to understand what you need — and every estimate is based on your actual requirements."
        testId="estimate-hero"
      />
      <div className="max-w-3xl mx-auto px-5 sm:px-8 pb-24 sm:pb-32">
        <Reveal>
          <EstimateForm compact />
        </Reveal>
      </div>
    </div>
  );
};

export default GetEstimatePage;
